<div class="col-lg-12 col-md-12 col-12">
    <div class="bk-title--default text-center mb--70">
         <h6 class="heading heading-h6 theme-color"></h6>
         <div class="bkseparator--30"></div>
         <h3 class="heading heading-h3"><br>Conexión Akashico<sup>®</sup>II Facilitador</h3>
     </div>
     <div class="row">
        
         <!-- Yessy Amor Cano Bracamontes -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9971215892.jpg" alt="Yessy Amor Cano Bracamontes">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Yessy Amor Cano Bracamontes</li>
                     <li>yessyamor@live.com.mx</li>
                     <li>TEL. 9971215892</li>
                     <li>Ticul, Yucatán</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          <!-- Start Single Testimonial -->
         <div class="col-lg-4 col-md-4 col-sm-12 col-12">
             <div class="testimonial testimonial_style--1">
                 <div class="content">
                    <div class="testimonial-info">
                         <div class="post-thumbnail">
                             <img src="assets/img/directorio/9381153124.jpg" alt="foto del estudiante">
                         </div>
                         
                     </div>
                     <p class="bk_pra"><br>
                     <li>Eyra Taihe Palmer Montejo</li>
                     <li>taipalmont@gmail.com</li>
                     <li>TEL. 9381153124</li>
                     <li>Ciudad del Carmen, Campeche</li>
                     <li>México</li>
                     </p>
                     
                     <div class="testimonial-quote">
                         <span class="fa fa-quote-right"></span>
                     </div>
                 </div>
             </div>
         </div>
         <!-- End Single Testimonial -->
         
          
        
        
         
         
         
         
         

       
     </div>
 </div>